export const iconFontAwesomeEditingRotate = (
	<i className="fa-solid fa-rotate"></i>
);
